// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useEffect, useState } from "react";
import { WIDTH_DEBOUNCE_MS } from "./types";
import { widthBucket } from "./lib/chartDocument";
/**
 * The element's width in 40 px steps, at least the minimum render width:
 * measured at once, then again after a resize settles, so dragging a window
 * does not ask for a render per pixel.
 */
export function useBucketedWidth(ref) {
    var _a = useState(null), width = _a[0], setWidth = _a[1];
    useEffect(function () {
        var element = ref.current;
        if (!element)
            return;
        var measure = function () {
            var measured = element.getBoundingClientRect().width;
            if (measured > 0)
                setWidth(widthBucket(measured));
        };
        measure();
        if (typeof ResizeObserver === "undefined")
            return;
        var timer;
        var observer = new ResizeObserver(function () {
            clearTimeout(timer);
            timer = setTimeout(measure, WIDTH_DEBOUNCE_MS);
        });
        observer.observe(element);
        return function () {
            clearTimeout(timer);
            observer.disconnect();
        };
    }, [ref]);
    return width;
}
